import { createContext } from 'react';

interface ProfileRestrictionContextValue {
  isRestricted: boolean;
  guardAction: (action: () => void) => void;
}

export const ProfileRestrictionContext =
  createContext<ProfileRestrictionContextValue | null>(null);
